import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { resetPassword } from '../../store/action/profile.action'
import { Row, Col, message, Spin, Form, Input, Card, Button } from 'antd'
import { Redirect } from 'react-router-dom'
import '../../css/resetpassword.scss'
import util from '../../util/util'

var cardSize =
  (window.innerWidth < window.innerHeight
    ? window.innerWidth
    : window.innerHeight) - 20

cardSize = cardSize < 450 ? cardSize : 450

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
}

const ResetPassword = (props) => {
  var onFinish = (value) => {
    props.resetPassword(value.oldpassword, value.newpassword)
  }

  return props.token == undefined || props.successMessage ? (
    <Redirect to='/login' />
  ) : (
    <>
      <Row type='flex' align='middle' className='resetRow center'>
        <Col span={24} flex='auto'>
          <div className='resetContainer'>
            <Card style={{ width: cardSize }}>
              <div className='header center'>
                <h1>Reset Password</h1>
              </div>
              <Form
                {...formItemLayout}
                name='normal_login'
                className='login-form'
                initialValues={{ remember: true }}
                onFinish={(value) => onFinish(value)}
              >
                <Form.Item
                  label='Old Password'
                  name='oldpassword'
                  rules={[
                    {
                      required: true,
                      message: 'Please input your Password!',
                    },
                  ]}
                >
                  <Input.Password placeholder='old password' />
                </Form.Item>
                <Form.Item
                  label='New Password'
                  name='newpassword'
                  rules={[
                    {
                      required: true,
                      message: 'Please input your Password!',
                    },
                    {
                      min: 8,
                      message: 'Password must be at least 8 characters long!',
                    },
                    {
                      pattern: /(?=.*[A-Z])/,
                      message: 'Password must contain at least one uppercase letter!',
                    },
                    {
                      pattern: /(?=.*[0-9])/,
                      message: 'Password must contain at least one number!',
                    },
                    {
                      pattern: /(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/,
                      message: 'Password must contain at least one special character!',
                    },
                  ]}
                  help='Password must be at least 8 characters with one uppercase letter, one number, and one special character'
                >
                  <Input.Password placeholder='Password' />
                </Form.Item>
                <Form.Item
                  label='Confirm Password'
                  name='confirmpassword'
                  hasFeedback
                  dependencies={['newpassword']}
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password!',
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue('newpassword') === value) {
                          return Promise.resolve()
                        }
                        return Promise.reject(
                          'The two passwords that you entered do not match!'
                        )
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder='Password' />
                </Form.Item>
                <Form.Item>
                  <Button htmlType='submit' className='submitBtn'>
                    Submit
                  </Button>
                </Form.Item>
                {props.hasError ? message.error(props.message) : null}
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
    </>
  )
}

ResetPassword.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
  successMessage: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    hasError: state.profile.resetError,
    message: state.profile.message,
    successMessage: state.profile.successMessage,
    isLoading: state.profile.isLoading,
    token: util.verifyToken(state.profile.token),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (oldpassword, newpassword) =>
      dispatch(resetPassword(oldpassword, newpassword)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
